// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-pathways-container {
    height: 82%;
    width: 460px;
    position: fixed;
    z-index: 99;
    top: 70px;
    right: 5px;
}

.add-pathways-container .path-img {
    border-radius: 13px;
    max-height: 250px;
    width: 100%;
}

.civ-message-body {
    display: flex;
}

.civ-message-body.from {
    justify-content: flex-start;
}

.civ-message-body.to {
    justify-content: flex-end;
}

.civ-message {
    display: inline-block;
    border-radius: 1.5rem;
    margin-bottom: 15px;
    padding: 8px 20px;
    position: relative;
}

.civ-message-body.to .civ-message {
    background-color: #9b4dca;
    color: #fff;
    margin-left: 100px;
}

.civ-message-body.from .civ-message {
    background-color: #E5E4E9;
    color: #363636;
    margin-right: 100px;
    white-space: pre-line;
}

.civ-message-body.to+.civ-message-body.to,
.civ-message-body.from+.civ-message-body.from {
    margin-top: -10px;
}

.civ-message-suggestion {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 5px;
}

.civ-message-suggestion label {
    cursor: pointer;
    padding: 4px 10px;
    color: #6e5eff;
    border: 1px solid #6e5eff;
    border-radius: 2rem;
    font-weight: 500;
}

.civ-no-profile {
    min-width: 30px;
}

.send-btn {
    margin: 10px 0 10px 10px;
    padding: 8px 10px;
}

.send-btn img {
    filter: brightness(0) invert(1);
}

.preDefineTopic {
    padding: 13px;
    border-radius: 12px;
    border: 1px solid rgba(0, 0, 0, .125);
    font-size: 14px;
    cursor: pointer;
}

.loopTopic {
    padding: 0px 6px 6px 0px;
}

.preDefineTopic p {
    color: #727272;
    font-size: 15px;
}

.preview-video-list-inner li {
    border: 1px solid #ddd;
    border-radius: 10px;
    padding: 10px;
    margin-bottom: 10px;
}

.preview-video-list-inner h6 {
    font-size: 14px;
}

.preview-video-list-inner img {
    cursor: pointer;
    flex-shrink: 0;
}

.preview-video-list-inner .preview-video-icon {
    width: 45px;
    height: 45px;
    background-color: #f1eafe;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    flex-shrink: 0;
}

@media (max-width: 500px) {
    .add-pathways-container {
        width: 300px;
    }

    .civ-message-body.from .civ-message {
        margin-right: 20px;
    }

    .civ-message-body.to .civ-message {
        margin-left: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/createInteractiveVideo/ai-video-creator-chat/ai-video-creator-chat.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".add-pathways-container {\n    height: 82%;\n    width: 460px;\n    position: fixed;\n    z-index: 99;\n    top: 70px;\n    right: 5px;\n}\n\n.add-pathways-container .path-img {\n    border-radius: 13px;\n    max-height: 250px;\n    width: 100%;\n}\n\n.civ-message-body {\n    display: flex;\n}\n\n.civ-message-body.from {\n    justify-content: flex-start;\n}\n\n.civ-message-body.to {\n    justify-content: flex-end;\n}\n\n.civ-message {\n    display: inline-block;\n    border-radius: 1.5rem;\n    margin-bottom: 15px;\n    padding: 8px 20px;\n    position: relative;\n}\n\n.civ-message-body.to .civ-message {\n    background-color: #9b4dca;\n    color: #fff;\n    margin-left: 100px;\n}\n\n.civ-message-body.from .civ-message {\n    background-color: #E5E4E9;\n    color: #363636;\n    margin-right: 100px;\n    white-space: pre-line;\n}\n\n.civ-message-body.to+.civ-message-body.to,\n.civ-message-body.from+.civ-message-body.from {\n    margin-top: -10px;\n}\n\n.civ-message-suggestion {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 5px;\n}\n\n.civ-message-suggestion label {\n    cursor: pointer;\n    padding: 4px 10px;\n    color: #6e5eff;\n    border: 1px solid #6e5eff;\n    border-radius: 2rem;\n    font-weight: 500;\n}\n\n.civ-no-profile {\n    min-width: 30px;\n}\n\n.send-btn {\n    margin: 10px 0 10px 10px;\n    padding: 8px 10px;\n}\n\n.send-btn img {\n    filter: brightness(0) invert(1);\n}\n\n.preDefineTopic {\n    padding: 13px;\n    border-radius: 12px;\n    border: 1px solid rgba(0, 0, 0, .125);\n    font-size: 14px;\n    cursor: pointer;\n}\n\n.loopTopic {\n    padding: 0px 6px 6px 0px;\n}\n\n.preDefineTopic p {\n    color: #727272;\n    font-size: 15px;\n}\n\n.preview-video-list-inner li {\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    padding: 10px;\n    margin-bottom: 10px;\n}\n\n.preview-video-list-inner h6 {\n    font-size: 14px;\n}\n\n.preview-video-list-inner img {\n    cursor: pointer;\n    flex-shrink: 0;\n}\n\n.preview-video-list-inner .preview-video-icon {\n    width: 45px;\n    height: 45px;\n    background-color: #f1eafe;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 10px;\n    flex-shrink: 0;\n}\n\n@media (max-width: 500px) {\n    .add-pathways-container {\n        width: 300px;\n    }\n\n    .civ-message-body.from .civ-message {\n        margin-right: 20px;\n    }\n\n    .civ-message-body.to .civ-message {\n        margin-left: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
